import PropTypes from 'prop-types';

const CampaignImage = ({ image, title }) => {
  return (
    <div className="mt-6 sm:mt-8 p-[5px] rounded-[5px]">
      <img
        src={image}
        alt={title}
        className="w-full object-cover rounded-[5px]"
        onError={(e) => {
          e.target.src = 'https://via.placeholder.com/350x324?text=Campaign+Image';
          e.target.alt = 'Image not available';
        }}
      />
    </div>
  );
};

CampaignImage.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
};

export default CampaignImage;